//
// DebugItem.js
// vav
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../lib";
import "../VAViewerModel";

var DebugItem = createModule("vav::DebugItem", ["commons::PropertyOwner","commons::BaseModel","vav::VAViewerModel"], EventDispatcher, [
    ,
    {
        name: 7,
        label: 7,
        content: 7,
    },
    ,
    ,
    ,
    {
        _create: [4],
    },
    ,
]);
export default DebugItem;
